import React, { Component } from 'react';
import CarouselComp from 'react-slick';
import Post from './post/carousel';
import { IComponent } from '../core/models/component';
import '../styles/carousel-post.scss';

interface IProps {
  data: {
    posts: [IComponent];
    id: string;
    domElement: any;
  };
}
const CustomPrevArrow = (props) => {
    const { className, onClick } = props;
    return (
      <div
        className={className}       
        onClick={onClick}
      >
       <img src="https://pancan.org/wp-content/uploads/2023/11/news-slider-arrow-left.png" alt="slider arrow"/>
      </div>
    );
  };

  const CustomNextArrow = (props) => {
    const { className, onClick } = props;
    return (
      <div
        className={className}
        onClick={onClick}
      >
        <img src="https://pancan.org/wp-content/uploads/2023/11/news-slider-arrow-right.png" alt="slider arrow"/>
      </div>
    );
  };
class Carousel extends Component<IProps> {
  componentDidMount() {
    const node = document.getElementById('carousel-component-' + this.props.data.id);
    this.props.data.domElement.appendChild(node);
  }

  

  public render() {
    const posts = this.props.data.posts || [];

    const settings = {
      slidesToShow: 3,
      autoplay: true,
      speed: 1200,
      autoplaySpeed: 8000,
      prevArrow: <CustomPrevArrow />, //'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><img src="https://pancan.org/wp-content/uploads/2023/11/news-slider-arrow-left.png" alt="slider arrow"/></button>',
      nextArrow: <CustomNextArrow />, //'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><img src="https://pancan.org/wp-content/uploads/2023/11/news-slider-arrow-right.png" alt="slider arrow"/></button>',
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            arrows: true,
            draggable: true,
            slidesToShow: 2,
            dots: true
          }
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            draggable: true,
            slidesToShow: 1,
            dots: true
          }
        }
      ]
    };
    return (
      <div className="carousel-component-holder" id={'carousel-component-' + this.props.data.id}>
        <CarouselComp {...settings}>
          {posts.map((post: any, key: number) => (
            <Post data={post} key={key} />
          ))}
        </CarouselComp>
      </div>
    );
  }
}

export default Carousel;
